import React from "react";
import PublicShell from "@/components/PublicShell";

export default function Privacy() {
  return (
    <PublicShell>
      <section className="max-w-3xl mx-auto px-6 md:px-10 py-16">
        <div className="text-eyebrow text-[#4F4D45]">Privacy policy</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-2">Your data, on your terms.</h1>
        <p className="text-[#4F4D45] mt-4">Last updated: February 2026</p>

        <div className="mt-10 space-y-8 text-[#0A0A08] leading-relaxed">
          <Section title="1. What we collect">
            We collect only what is needed to operate your wallet: your name, email, password (hashed), account type (personal/business), business name (if applicable), wallet activity, and card metadata (brand, holder, last 4 digits). We do <strong>not</strong> store full card numbers or CVVs.
          </Section>
          <Section title="2. Why we collect it">
            To create and secure your account, send verification codes, process deposits/withdrawals/transfers, prevent fraud, and meet legal obligations.
          </Section>
          <Section title="3. Email & verification">
            We use Resend to deliver one-time verification codes to your email at registration and at every login. Emails contain only your code, the purpose, and standard branding.
          </Section>
          <Section title="4. Payments via PayPal">
            Live-mode deposits are processed by PayPal. When you pay with a card, you interact directly with PayPal's checkout. We receive only an order confirmation — never your card data.
          </Section>
          <Section title="5. Cookies & sessions">
            We set two HTTP-only, signed cookies (access &amp; refresh tokens) to maintain your session. They cannot be read by JavaScript and are scoped to the FinVault domain.
          </Section>
          <Section title="6. Security measures">
            Passwords are hashed with bcrypt. Sessions use signed JWTs with short access lifetimes and rotating refresh tokens. We enforce brute-force lockouts after repeated failed logins. Two-factor authentication is available via TOTP.
          </Section>
          <Section title="7. Data retention">
            Account data is kept while your account is active. Verification codes expire after 10 minutes. Password reset tokens expire after 1 hour. Login attempt counters reset after 15 minutes of inactivity.
          </Section>
          <Section title="8. Your rights">
            You may request export or deletion of your account data at any time by emailing privacy@finvault.capital. We respond within 30 days.
          </Section>
          <Section title="9. Changes">
            Material changes to this policy will be communicated via email at least 14 days before they take effect.
          </Section>
          <Section title="10. Contact">
            For privacy questions, email <a href="mailto:privacy@finvault.capital" className="text-[#1B3526] underline">privacy@finvault.capital</a>.
          </Section>
        </div>
      </section>
    </PublicShell>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl md:text-2xl font-medium">{title}</h2>
      <p className="text-[#4F4D45] mt-3">{children}</p>
    </div>
  );
}
